import React from 'react';
import { Trophy } from 'lucide-react';

const PowerRankingsBanner = () => {
  // Randomly select one of the two images for mobile
  const mobileImage = Math.random() < 0.5 ? '/beastlift1.png' : '/beastlift2.png';
  const mobileAlt = mobileImage.includes('lift1') ? 'Beast Lifting 1' : 'Beast Lifting 2';
  
  return (
    <div className="relative bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 rounded-2xl shadow-xl overflow-hidden min-h-[200px]">
      {/* Mobile: Single background image */}
      <div className="block lg:hidden absolute inset-0 flex items-center justify-center">
        <img 
          src={mobileImage}
          alt={mobileAlt}
          className="w-[60%] h-[60%] object-contain opacity-25"
          style={{ 
            objectPosition: 'center center',
            maskImage: 'radial-gradient(ellipse at center, black 50%, transparent 85%)',
            WebkitMaskImage: 'radial-gradient(ellipse at center, black 50%, transparent 85%)'
          }}
        />
      </div>

      {/* Enhanced Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-1/4 w-32 h-32 bg-white/5 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-20 right-1/4 w-24 h-24 bg-yellow-400/10 rounded-full blur-lg animate-bounce"></div>
        <div className="absolute top-1/3 right-1/3 w-16 h-16 bg-blue-400/10 rounded-full blur-md animate-pulse delay-300"></div>
        
        {/* Additional Floating Particles */}
        <div className="absolute top-10 right-10 w-6 h-6 bg-orange-400/30 rounded-full animate-bounce delay-500"></div>
        <div className="absolute bottom-10 left-20 w-4 h-4 bg-yellow-400/40 rounded-full animate-ping"></div>
        <div className="absolute top-1/2 left-10 w-8 h-8 bg-red-400/20 rounded-full animate-pulse delay-700"></div>
        <div className="absolute bottom-1/3 right-1/2 w-5 h-5 bg-amber-400/35 rounded-full animate-bounce delay-1000"></div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 p-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center min-h-[200px]">
          {/* Left Beast Image - Desktop Only */}
          <div className="hidden lg:flex col-span-1 justify-start items-end h-full">
            <img 
              src="/beastlift1.png" 
              alt="Beast Lifting 1" 
              className="w-64 h-64 lg:w-88 lg:h-88 object-contain opacity-80"
              style={{ 
                transform: 'translateY(32px) translateX(8px)',
                maskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)',
                WebkitMaskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)'
              }}
            />
          </div>

          {/* Center - Text Content */}
          <div className="col-span-1 lg:col-span-3 text-center">
            <div className="flex items-center justify-center mb-4">
              <div>
                <h1 className="text-4xl lg:text-5xl font-black text-white mb-2 tracking-tight drop-shadow-lg">
                  Power Rankings
                </h1>
                <p className="text-blue-100 text-lg lg:text-xl font-medium drop-shadow-md">
                  Manager strength rankings based on all-play performance
                </p>
              </div>
            </div>
          </div>

          {/* Right Beast Image - Desktop Only, Flipped to Face Center */}
          <div className="hidden lg:flex col-span-1 justify-end items-end h-full">
            <img 
              src="/beastlift2.png" 
              alt="Beast Lifting 2" 
              className="w-64 h-64 lg:w-88 lg:h-88 object-contain opacity-80"
              style={{ 
                transform: 'translateY(32px) translateX(-8px) scaleX(-1)',
                maskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)',
                WebkitMaskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PowerRankingsBanner;